import type { ReactElement, ReactNode } from "react";
import { displayFontClassName } from "@/lib/fonts";
import { cn } from "@/lib/utils";

interface HeroTitleProps {
  children: ReactNode;
  className?: string;
}

/** Hero H1 — Figma: 32px mobile, 48px от md (tablet stacked), desktop row с 1440px. */
export function HeroTitle({ children, className }: HeroTitleProps): ReactElement {
  return (
    <h1 className={cn(displayFontClassName, "hero-title", className)}>
      {children}
    </h1>
  );
}
